import { useEffect, useState, useContext, useRef } from "react";
import { Link } from "react-router-dom"
import { ConfigContext } from "../../../Contexts/Config";
import Loader from "../../UI/Loader/loader";
import SearchReviews from "../../UI/SearchReviews/SearchReviews";

import Moment from 'moment';
 
import parse from 'html-react-parser';
import ProfileSidebar from "../../ProfileSidebar/ProfileSidebar";
import { AuthContext } from "../../../Contexts/Auth";
import { SearchReviewsContext } from "../../../Contexts/SearchReviews";
 
export default function Reviews(){

    const {user} = useContext(AuthContext)

    const {searchReviews, filterReviews} = useContext(SearchReviewsContext)   

    const [Reviews, setReviews] = useState()

    let {api_urls} = useContext(ConfigContext)

    const token = JSON.parse(localStorage.getItem("user")).token

    let dFrom = new Date() 

    dFrom.setMonth(dFrom.getMonth() - 1);

    let dTo = new Date() 

    let statusApp = 0

    if (searchReviews){
      dFrom = new Date(searchReviews.dateFrom)
      dTo = new Date(searchReviews.dateTo)
      statusApp = searchReviews.status
    } 
 
    const [dateFrom, setDateFrom] = useState(dFrom)

    const [dateTo, setDateTo] = useState(dTo)

    const [status, setStatus] = useState(statusApp)

    let shouldLog = useRef(true)

    const [recordCount, setRecordCount] = useState("0")

    useEffect(() => {

        setReviews()

        if (shouldLog.current){
           
          shouldLog.current = false

          let urlSearch = `reviews?rating=${status}&date_from=${Moment(dateFrom).format('YYYY-MM-DD')}&date_to=${Moment(dateTo).format('YYYY-MM-DD')}`

          console.log(urlSearch)

          //urlSearch = 'reviews'

          fetch(
              `${api_urls.cmg}/${urlSearch}`,{
                  method: 'GET',
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
              }
          )
          .then((response) => response.json())
          .then((Reviews) => {

              //console.log(Reviews)

              setRecordCount(Reviews.total)

              //const sliceData = Reviews.data.slice(0,10)

              setReviews(Reviews.data)

              filterReviews(dateFrom, dateTo, status)
          })
        }
        
    },[status,dateFrom,dateTo])


    return <div className="content">
    <div className="container-fluid">
      <div className="row">
        {/* Profile Sidebar */}
        <div className="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
          <ProfileSidebar/>
          {/* Search Appointmenmts */}
          <SearchReviews 
            dateFrom={dateFrom} 
            setDateFrom={setDateFrom}
            dateTo={dateTo} 
            setDateTo={setDateTo}
            status = {status}
            setStatus = {setStatus}
            shouldLog = {shouldLog}
          />
          {/* Search Appointmenmts */}
        </div>
        {/* / Profile Sidebar */}
        <div className="col-md-7 col-lg-8 col-xl-9">
          <div className="card">
            <div className="card-body pt-0">
              {/* Tab Menu */}
              <nav className="user-tabs mb-4">
                <ul className="nav nav-tabs nav-tabs-bottom nav-justified">
                  <li className="nav-item">
                    <a className="nav-link active" href="#pat_Reviews" data-toggle="tab">
                      Recensioni {recordCount}
                    </a>
                  </li>
                </ul>
              </nav>
              {/* /Tab Menu */}
              {/* Tab Content */}
              <div className="tab-content pt-0">
                {/* Appointment Tab */}
                <div id="pat_Reviews" className="tab-pane fade show active">
                  <div className="card card-table mb-0">
                    <div className="card-body">
                      <div className="table-responsive">
                        <table className="table table-hover table-center mb-0">
                          <thead>
                            <tr>
                              <th>Appuntamento</th>
                              <th>Paziente</th>
                              <th>Data</th>
                              <th>Valutazione</th>
                              <th /><th />
                            </tr>
                          </thead>
                          <tbody>
                            {
                            Reviews &&
                            Reviews.map((review) => {
                                return(<tr key={review.id}>
                                    <td>
                                        <span className="LabelGrid">Appuntamento</span>
                                         <span>{ review.imported} </span>
                                    </td>
                                    <td>
                                      <span className="LabelGrid">Paziente</span>
                                      { 
                                        <span>{ review.surname+' '+review.name} </span>
                                      }
                                    </td>
                                    <td>
                                        <span className="LabelGrid">Data</span>
                                        {review.review_date}
                                    </td>
                                    <td>
                                        <span className="LabelGrid">Valutazione</span>                                                  
                                        {review.rating}
                                        
                                    </td>
                                    <td className="text-right">
                                        <span className="LabelGrid" />
                                        <div className="table-action">
                                        
                                        </div>
                                    </td>
                                    <td className="text-right">
                                        <span className="LabelGrid" />
                                        <div className="table-action">
                                        </div>
                                    </td>
                                    </tr> )
                                })
                            }
                            { !Reviews && <tr>
                                <td></td>
                                <td></td>
                                <td>
                                    <Loader/>
                                    <br/><br/><br/>
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                              </tr> 
                            }  
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Appointment Tab */}
              </div>
              {/* Tab Content */}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
}